import type { ReactNode } from 'react';

export const symbol_game_stick_right: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M721-437.08q99-52.08 99-126T721-689q-99-52-241-52t-241 52.08q-99 52.08-99 126T239-437q99 52 241 52t241-52.08ZM674-356v136q0 24.75-17.62 42.37Q638.75-160 614-160H345q-24.75 0-42.37-17.63Q285-195.25 285-220v-136q-92-31-148.5-85.51Q80-496.02 80-562.8 80-662 196.5-731 313-800 480-800t283.5 69.25Q880-661.51 880-563q0 67.24-56.5 122.12Q767-386 674-356ZM480-563Zm-38.5 101.5Q446-466 446-472v-67h37l44 75q2 3 5.38 5 3.39 2 7.62 2 8.87 0 12.93-7.5Q557-472 552-480l-42-68q20-8 30-21.36 10-13.37 10-33.64 0-30-19-45t-56-15h-43.87q-6.05 0-10.59 4.5T416-648v176q0 6 4.5 10.5T431-457q6 0 10.5-4.5ZM446-567v-67h27q23 0 34.5 8t11.5 24.94Q519-583 508-575t-35 8h-27Z"
		/>
	</svg>
);
